import { adminHttpClient } from '../../../../commons/adminHttpClient'

export interface SetAllowanceValues {
  productClassId: string | null
  offerSameAllowance: boolean | null
  allowanceAmount: Array<AllowanceAmountValue>
  planPeriodId?: string
}

export interface AllowanceAmountValue {
  familyStatusId: number | undefined
  amount: number | undefined
}

const setAllowanceApi = (setAllowanceValues: SetAllowanceValues): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/ClassDesign/SetAllowance', setAllowanceValues)
}

export default setAllowanceApi
